import { Component, Vue, Mixins, Watch } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';
import SBAPI from '@/util/SBAPI';
import { AxiosErrorHandler, isAxiosError } from '@/util/AxiosErrorHandler';
import { ArtistPageTypeEnum, ArtistTypeEnum } from '@/generated/api';

@Component({
    components: AllComponents(),
})
export default class Category extends Mixins(CommonView) {
    artistList: SBAPI.Artist[] | null = null;
    endArtistList: SBAPI.Artist[] | null = null;
    artistTypeList: string[] = [];
    kurukuru: boolean = false;

    @Watch('$route')
    public async init() {
        this.kurukuru = true;
        this.artistTypeList = [];
        let res;
        if (this.$route.params.category) {
            let artistTypeStringList = this.$route.params.category.split("-");
            for (const artistTypeString of artistTypeStringList) {
                let artistType = this.toArtistType(artistTypeString);
                if (artistType) {
                    this.artistTypeList.push(artistType);
                }
            }
            res = await SBAPI.ArtistController.getCategoryArtistListUsingGET(this.artistTypeList[0] === "SPECIAL" ? [ArtistTypeEnum.EVENT] : <any[]>this.artistTypeList).catch(AxiosErrorHandler);
        } else {
            this.artistTypeList.push("ALL");
            res = await SBAPI.ArtistController.getArtistListUsingGET().catch(AxiosErrorHandler);
        }
        if (!isAxiosError(res)) {
            let artistList = [];
            let endArtistList = [];

            if (res.data && res.data.length > 0) {
                for (const artist of res.data) {
                    if (!artist.planList || artist.planList.length == 0) {

                        if (artist.pageType !== ArtistPageTypeEnum.NORMAL && artist.pageType !== ArtistPageTypeEnum.NORMAL2) {
                            let res = await SBAPI.ArtistController.getArtistByTagUsingGET(artist.slug).catch(AxiosErrorHandler);
                            if (!isAxiosError(res)) {
                                for (let i = 0; i < res.data.length; i++) {
                                    if (res.data[i].planList && res.data[i].planList!.length > 0) {
                                        for (let index = 0; index < res.data[i].planList!.length; index++) {
                                            if (res.data[i].planList![index].sort > 0 && new Date(res.data[i].planList![index].openDate!) < new Date(res.headers.date) && (res.data[i].planList![index].currentOrder || (res.data[i].planList![index].nextOrder && res.data[i].planList![index].nextOrder!.name))) {
                                                artistList!.push(artist);
                                                i = res.data.length;
                                                break;
                                            }

                                        }
                                    }
                                    if (i == res.data.length - 1) {
                                        endArtistList!.push(artist);
                                    }
                                }
                            }
                            continue;
                        }
                        endArtistList!.push(artist);
                        continue;
                    }

                    for (let index = 0; index < artist.planList.length; index++) {
                        if (artist.planList[index].sort > 0 && new Date(artist.planList[index].openDate!) < new Date(res.headers.date) && (artist.planList[index].currentOrder || (artist.planList[index].nextOrder && artist.planList[index].nextOrder!.name))) {
                            artistList!.push(artist);
                            break;
                        }
                        if (index == artist.planList.length - 1) {
                            endArtistList!.push(artist);
                        }
                    }
                }
            }
            this.artistList = artistList;
            this.endArtistList = endArtistList;
            this.kurukuru = false;
        }
    }

    public async created() {
        await this.init();
    }
}
